import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot.component';
import { ForgotRoutingModule } from './forgot-routing';
import { ForgotPasswordService } from './forgot.password.service';
import { SharedModule } from '../../shared/shared.module';
import { FooterComponent } from "../../footer/footer.component";



@NgModule({ declarations: [
        ForgotPasswordComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ForgotRoutingModule,
        SharedModule,
        FooterComponent], providers: [ForgotPasswordService, provideHttpClient(withInterceptorsFromDi())] })
export class ForgotModule { }
